import { useCallback, useState } from 'react';

type UseSelectedRowReturn = {
    selectedRows: Record<string, any>;
    setSelectedRows: (rows: any[], ignoreCurrentSelection?: boolean, replaceAll?: boolean) => void;
};

export const useSelectRow = (alternateKey?: string): UseSelectedRowReturn => {
    const [selectedRows, _setSelectedRows] = useState<Record<string, any>>({});

    const setSelectedRows = useCallback(
        (rows: any[], ignoreCurrentSelection?: boolean, replaceAll?: boolean): void => {
            if (rows.length === 0) {
                _setSelectedRows({});
                return;
            }
            if (replaceAll) {
                const newSelectedRows: Record<string, any> = {};
                rows.forEach(row => {
                    const key = alternateKey ? row[alternateKey] : row.Id;
                    newSelectedRows[key] = row;
                });
                _setSelectedRows(newSelectedRows);
                return;
            }
            _setSelectedRows(prev => {
                let newSelectedRows = { ...prev };
                rows.forEach(row => {
                    const key = alternateKey ? row[alternateKey] : row.Id;

                    if (!newSelectedRows[key]) {
                        newSelectedRows[key] = row;
                    } else if (!ignoreCurrentSelection) {
                        /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
                        const { [key]: val, ...restRecord } = newSelectedRows;
                        newSelectedRows = restRecord;
                    }
                });
                return newSelectedRows;
            });
        },
        [alternateKey],
    );

    return {
        selectedRows,
        setSelectedRows,
    };
};
